// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.QB = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.QB = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var QB = _exports.QB = function QB(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14258)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.41076 9.99758C2.41156 12.2584 4.23476 14.0968 6.49556 14.1168H7.07396V12.6056H6.49556C5.09396 12.988 3.64836 12.1616 3.26676 10.76C3.26356 10.7488 3.26116 10.7376 3.25796 10.7264C2.86516 9.30638 3.68756 7.83518 5.10276 7.42638H5.39156C5.75396 7.34718 6.12916 7.34718 6.49156 7.42638H7.89636V15.4496C7.88916 16.2984 8.57156 16.9928 9.42036 17.0008V5.83758H6.50436C4.22756 5.84958 2.39236 7.70478 2.40436 9.98158V9.98238L2.41076 9.99758ZM13.5108 5.83918H12.9324V7.43038H13.5108C14.9092 7.04878 16.3516 7.87278 16.7332 9.27038C16.7364 9.28078 16.7388 9.29198 16.742 9.30238C17.1324 10.7176 16.3124 12.1832 14.9028 12.5912H14.614C14.2516 12.6704 13.8764 12.6704 13.514 12.5912H12.1092V4.56878C12.1164 3.71998 11.434 3.02558 10.5852 3.01758V14.1968H13.5012C15.798 14.1608 17.6308 12.2704 17.5956 9.97358C17.5604 7.72718 15.7484 5.91438 13.5012 5.87918L13.5108 5.83918Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14258"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
